import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import Home from "./views/Home.vue";
import Admin from "./views/Admin.vue";
import AdminBasic1 from "./components/Admin/AdminBasic1.vue";
import AdminTopImage from "./components/Admin/AdminHeroImage.vue";
import AdminCase from "./components/Admin/AdminCase.vue";
import AdminService from "./components/Admin/AdminService.vue";
import AdminFaq from "./components/Admin/AdminFaq.vue";
import AdminEmail from "./components/Admin/AdminEmail.vue";
import AdminPassword from "./components/Admin/AdminPassword.vue";
import Login from "./views/Login.vue";
import LoginForgotPassword from "./components/Login/LoginForgotPassword.vue";
const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "/login",
    name: "login",
    component: Login,
  },
  {
    path: "/forgotPassword",
    name: "forgotPassword",
    component: LoginForgotPassword,
  },
  {
    path: "/admin",
    name: "admin",
    component: Admin,
    children: [
      {
        path: "",
        component: AdminBasic1,
      },
      {
        path: "topimage",
        component: AdminTopImage,
      },
      {
        path: "case",
        component: AdminCase,
      },
      {
        path: "service",
        component: AdminService,
      },
      {
        path: "faq",
        component: AdminFaq,
      },
      {
        path: "email",
        component: AdminEmail,
      },
      {
        path: "password",
        component: AdminPassword,
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  // linkActiveClass: "active",
  scrollBehavior(to) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: "smooth",
      };
    }
  },
});

export default router;
